// extracted by mini-css-extract-plugin
module.exports = {"design":"SearchBar_design__1Kp9b","ie":"SearchBar_ie__3i8mD","glow":"SearchBar_glow__nYRYb"};